const toolToneByPath = {
  '/jpeg-compressor': 'tone-cyan',
  '/png-compressor': 'tone-blue',
  '/webp-converter': 'tone-green',
  '/compress-image-to-100kb': 'tone-violet',
  '/image-resizer': 'tone-amber',
};

export const getToolTone = (path) => toolToneByPath[path] || 'tone-cyan';
